<template>
	<nav aria-label="Progress">
		<ol
			class="border border-gray-200 rounded-md divide-y divide-gray-200 md:flex md:divide-y-0 progress-nav"
		>
			<li
				v-for="(header, headerIdx) in steps"
				:key="header.name"
				class="relative md:flex-1 md:flex justify-center transition-all duration-75 transform ease-in-out"
				:class="{ current: header.status === 'current' }"
			>
				<a
					v-if="header.status === 'complete'"
					:href="header.href"
					class="group flex md:justify-center items-center w-full"
				>
					<span class="px-6 py-4 flex items-center text-sm font-medium">
						<span
							class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-brand rounded-full group-hover:bg-secondary"
						>
							<CheckIcon class="w-6 h-6 text-white" aria-hidden="true" />
						</span>
						<span
							class="ml-4 text-sm font-medium text-brand group-hover:text-secondary"
						>
							{{ header.name }}
						</span>
					</span>
				</a>
				<a
					v-else-if="header.status === 'current'"
					:href="header.href"
					class="px-6 py-4 flex items-center text-sm font-medium group"
					aria-current="header"
				>
					<span
						class="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-100 group-hover:bg-white group-hover:border-0 rounded-full"
					>
						<span class="text-gray-100 group-hover:text-secondary">
							{{ header.id }}
						</span>
					</span>
					<span class="ml-4 text-sm font-semibold text-white animate-pulse">
						{{ header.name }}
					</span>
				</a>
				<a v-else :href="header.href" class="group flex items-center">
					<span class="px-6 py-4 flex items-center text-sm font-medium">
						<span
							class="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full group-hover:border-gray-400"
						>
							<span class="text-gray-500 group-hover:text-gray-900">
								{{ header.id }}
							</span>
						</span>
						<span
							class="ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900"
						>
							{{ header.name }}
						</span>
					</span>
				</a>
				<template v-if="headerIdx !== steps.length - 1">
					<div
						class="hidden md:block absolute top-0 right-0 h-full w-5 -mr-3"
						aria-hidden="true"
					>
						<svg
							class="h-full w-full text-gray-300"
							viewBox="0 0 22 80"
							fill="none"
							preserveAspectRatio="none"
						>
							<path
								d="M0 -2L20 40L0 82"
								vector-effect="non-scaling-stroke"
								stroke="currentcolor"
								stroke-linejoin="round"
							/>
						</svg>
					</div>
				</template>
			</li>
		</ol>
	</nav>
</template>

<script>
import { CheckIcon } from '@heroicons/vue/solid'

export default {
	components: {
		CheckIcon,
	},
	props: {
		steps: {
			type: Array,
			required: true,
		},
	},
	setup() {
		return {}
	},
}
</script>

<style>
.progress-nav {
	overflow: hidden;
}
.progress-nav li.current:first-child:before {
	padding-left: 550px;
	right: 0;
	left: auto !important;
}
.progress-nav li.current:first-child:after {
	padding-left: 550px;
	right: 0;
	left: auto !important;
}

.progress-nav li.current:last-child:after,
.progress-nav li.current:last-child:before {
	width: 110%;
}
.progress-nav li.current:before,
.progress-nav li.current:after {
	content: '';
	position: absolute;
	transition: background 0.8s;
	z-index: -1;
}
.progress-nav li.current:before {
	@apply bg-brand;
	height: 50%;
	width: 100%;
	top: 0;
	left: 0;
	transform: none;
}
.progress-nav li.current:after {
	@apply bg-brand;
	height: 50%;
	width: 100%;
	top: 50%;
	left: 0;
	transform: none;
}

@media (min-width: 768px) {
	.progress-nav li.current:before {
		transform: skew(25deg);
	}
	.progress-nav li.current:after {
		transform: skew(-25deg);
	}
}
</style>
